import './AddButton.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DefaultButton from '../DefaultButton/DefaultButton'

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const AddButton = ({ children, ...otherProps }: IProps) => {

  return (
    <DefaultButton title='Add' className='mb-2 mb-md-0 btn-lg btnWidth' variant='primary' {...otherProps}>
      <FontAwesomeIcon icon={['fas', 'plus-circle']} />&nbsp;
      {children ? children : <span>Add</span>}
    </DefaultButton>

  )
}

export default AddButton